import styles from "./Address.module.css";
import addressImg from "../../assets/images/address-bg.png";

const Address = () => {
  return (
    <section
      className={styles.section}
      style={{ backgroundImage: `url(${addressImg})` }}
    >
      <div className={`${styles.container} ${styles["container--1"]}`}>
        <h4 className={styles.title}>
          We Are <br className={styles.break} /> Located At!!!!
        </h4>
      </div>
      <div className={`${styles.container} ${styles["container--2"]}`}>
        <h5 className={styles.subtitle}>Address</h5>
        <p className={styles.content}>
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ea,
          accusamus, nemo animi aspernatur libero error omnis sed quidem tempore
          architecto, quas tempora nam nostrum expedita?
        </p>
      </div>
    </section>
  );
};

export default Address;
